/**
 * Zod schema for the `notificationReceipts` collection.
 *
 * Per-person delivery/read tracking. Created by Cloud Functions only
 * (rules: `allow create: if false`). Owner reads only.
 *
 * ADR-136/137: keyed by `personId`. Mobile clients read `personId` from
 * the auth token's custom claim (`request.auth.token.personId`) and
 * query receipts via that personId. FCM push delivery resolves
 * `persons[personId].authUid` and email delivery resolves
 * `personProfiles[personId].email` at fan-out time — no uid projection
 * cache is maintained on the audience.
 */

import { z } from 'zod';
import type { TimestampLike } from '../types/common';

export const notificationReceiptDocumentSchema = z.object({
  eventId: z.string(),
  notificationId: z.string(),
  personId: z.string(),
  /** null = delivered but unread. */
  readAt: z.custom<TimestampLike>().nullable(),
  /** Delivery time. Mirrors BaseDocument.createdAt for this collection. */
  createdAt: z.custom<TimestampLike>(),
});
